export default __webpack_public_path__ + "static/media/backingCake.7419932f.jpg";